<template>
  <editable-box
    :includeBtns="['drag', 'setup', 'delete', 'add']"
    :mode="mode"
    @onSetup="handleSetup"
    @onAdd="handelAdd"
    @onDelete="handelDelete"
  >
    <div class="attr-box" ref="attrBox">
      <div class="title">
        <text-box
          type="editor"
          position="rightTop"
          :mode="mode"
          :image-style="{ height: '22px' }"
          :value="data.title"
          @onChange="handleTitleChange"
        >
          {{ data.title || "标题" }}
        </text-box>
      </div>
      <div class="content" :class="{ 'is-edit': mode == 'edit' }" @dblclick.stop="handleOpenEdit">
        <text-box
          ref="contentEditorBox"
          type="editor"
          position="rightTop"
          :mode="mode"
          :image-style="{ height: '22px' }"
          :value="data.content"
          @onChange="handleContentChange"
        >
          {{ data.content || "内容" }}
        </text-box>
      </div>
      <setup-panel v-if="mode === 'edit'" ref="setupPanel" :data="data" @onChange="handleItemSetup"></setup-panel>
    </div>
  </editable-box>
</template>

<script>
// components
import TextBox from "../../../../components/TextBox";
import EditableBox from "../../../../components/EditableBox/index.jsx";
import SetupPanel from "./SetupPanel";

export default {
  name: "AttrBox",
  components: {
    TextBox,
    EditableBox,
    SetupPanel
  },
  props: {
    mode: String,
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isEdit: false,
      showPanel: false
    };
  },

  methods: {
    handleOpenEdit() {
      if (this.mode != "edit") return;
      this.$refs.contentEditorBox.openEdit();
    },
    handleSetup() {
      this.$refs.setupPanel.open();
    },
    handelAdd() {
      this.$emit("onAdd");
    },
    handelDelete() {
      this.$emit("onDelete");
    },
    handleTitleChange(title) {
      const data = JSON.parse(JSON.stringify(this.data));
      data.title = title;
      this.$emit("onChange", data);
    },
    handleContentChange(content) {
      const data = JSON.parse(JSON.stringify(this.data));
      data.content = content;
      this.$emit("onChange", data);
    },
    handleItemSetup(data) {
      this.$emit("onChange", data);
    }
  }
};
</script>

<style lang="less" scoped>
.attr-box {
  display: inline-flex;
  vertical-align: middle;
  width: 100%;
  min-height: 32px;
  padding: 0 15px;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  background: #fafafa;
  border-radius: 4px;
  .title {
    flex: 1;
    min-width: 60px;
    max-width: 50%;
    min-height: 22px;
    font-size: 14px;
    font-weight: bold;
    color: #212121;
    line-height: 22px;
  }

  .content {
    justify-self: flex-end;
    font-size: 14px;
    font-weight: 400;
    color: #373737;
    line-height: 22px;
    min-width: 50%;
    display: flex;
    flex-direction: row-reverse;
    &.is-edit {
      &:hover {
        background-color: #c7ccd5;
        outline: #c7ccd5;
        outline-style: solid;
        outline-width: 3px;
        cursor: pointer;
        // 显示编辑按钮

        /deep/ .edit-btns-wrapper {
          display: inline-flex;
        }
      }
    }
  }
}
</style>
